// Frontend route -> "feature" label (mirrors src/config/routeConfig.js). First match
// wins, so list specific prefixes before parents.
// Authoritative source for the user-facing vocabulary; the backend map
// (caddie_report/activity/feature_map.py) mirrors shared labels (not 1:1 - routes vs paths).
const RULES = [
    ['/dashboards', 'ACE dashboards'],
    ['/dashboard', 'Dashboard'],
    ['/search', 'Case search'],
    ['/procedures/', 'Procedure view'],
    ['/p/', 'Procedure view'],
    ['/perfedit/', 'Performance editing'],
    ['/performance', 'Performance search'],
    ['/edit/', 'Timeline editing'],
    ['/review/', 'Review / count editing'],
    ['/assessments', 'Case assessment'],
    ['/annotation/', 'Annotation'],
    ['/clinicalsummary', 'Clinical summary'],
    ['/summary/', 'Procedure summary'],
    ['/patient/', 'Patient reports'],
    ['/hospitals', 'Hospital management'],
    ['/installations', 'Install analytics'],
    ['/medaffairs', 'Medical affairs'],
    ['/caq/', 'CAQ (multi-rater)'],
    ['/cat', 'CAT upload'],
    ['/settings', 'Account settings'],
    ['/about', 'About'],
];

export function featureForPath(pathname) {
    const p = pathname || '/';
    for (const [prefix, feature] of RULES) {
        if (p === prefix || p.startsWith(prefix)) return feature;
    }
    return 'Other';
}

// Sub-feature from the URL for tabbed/stepped pages (/clinicalsummary/:tab,
// /assessments?step=...). Single-page views return null here (UsageSection sets it).
export function subFeatureForLocation(location) {
    const path = location?.pathname || '';
    if (path.startsWith('/clinicalsummary/')) {
        const tab = path.split('/')[2];
        return tab ? `tab:${tab}` : null;
    }
    if (path.startsWith('/assessments')) {
        const step = new URLSearchParams(location?.search || '').get('step');
        return step ? `step:${step}` : null;
    }
    return null;
}
